import React, { useState } from "react";
import SwitchPaddle from "./switchpaddle";

const SortNavItem = (props: any) => {
  const [firstSelected, setFirstSelected] = useState(false);
  const [preselected, setPreselected] = useState(
    typeof props.tab.preselected !== "undefined" && props.tab.preselected === true ? true : false,
  );
  let tab = props.tab;
  let _classes =
    "tabs-title column" +
    (typeof tab.xlargeWidth !== "undefined" ? " xlarge-" + tab.xlargeWidth : "") +
    (typeof tab.largeWidth !== "undefined" ? " large-" + tab.largeWidth : "") +
    (typeof tab.mediumWidth !== "undefined" ? " medium-" + tab.mediumWidth : "") +
    (typeof tab.smallWidth !== "undefined" ? " small-" + tab.smallWidth : "") +
    (typeof tab.extraClasses !== "undefined" ? " " + tab.extraClasses : "");
  /* let extra_classes = props.tab.extraClasses ? props.tab.extraClasses : ""; */
  if (typeof tab.sort !== "undefined") {
    //tab.sort.direction = (tab.sort.direction == 'desc' ? 'asc' : 'desc');
  }
  let isCheckbox = typeof tab.isCheckbox !== "undefined" && tab.isCheckbox;
  /* this is necessary to automatically highlight tab if preselected
       and set the right icon for sort direction */
  const isPreselected = () => {
    if (preselected && !firstSelected) {
      // preselected and has never been selected before
      tab.sort.direction = tab.sort.direction == "desc" ? "asc" : "desc";
      return true;
    }
    return false;
  };

  // this is necessary to keep highlighting functionality when using preselection feature
  const onClickHandler = (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    setFirstSelected(true); // tab has now been selected once
    props.handler(e);
  };
  const onChangeAll = (e: React.ChangeEvent<HTMLInputElement>, name: string) => {
    props.tab.onChange(e, !props.tab.value);
  };
  if (!tab.canSort && !isCheckbox) {
    return (
      <>
        <li
          className={_classes}
          title={tab.title}
          style={typeof tab.style !== "undefined" ? tab.style : {}}
        >
          <a href="#" aria-selected="true" /* className={extra_classes} */>
            {tab.name}&nbsp;
          </a>
        </li>
      </>
    );
  } else if (isCheckbox) {
    return (
      <>
        <li
          className={_classes}
          title={tab.title}
          style={typeof tab.style !== "undefined" ? tab.style : {}}
        >
          <SwitchPaddle
            name={props.tab.name}
            value={props.tab.value}
            onChange={onChangeAll}
            paddle={false}
            checkBoxStyle={props.tab.checkBoxStyle}
            checkBoxLabel={props.tab.checkBoxLabel}
          />
        </li>
      </>
    );
  } else {
    return (
      <>
        <li
          className={_classes + (isPreselected() || firstSelected ? " is-active" : "")}
          data-inb-val={tab.sort.data_inb_val}
          onClick={(e) => onClickHandler(e)}
          data-inb-direction={tab.sort.direction}
          title={tab.title}
          style={typeof tab.style !== "undefined" ? tab.style : {}}
        >
          <a href="#" aria-selected="true" /* className={extra_classes} */>
            {tab.name} <i className="fi-play"></i>
          </a>
        </li>
      </>
    );
  }
};

export default SortNavItem;
